import { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { GetSession } from 'session-manager-beta';
import { setOpen } from '../../Redux/Services/headerSlice';
import { NotificationSound } from '../CommonComponents/CommonNotification';

const Sidebar = () => {
    const [menus, setMenus] = useState([
        {
            "mSortNo": "1",
            "cssClass": "fa fa-dashboard",
            "menuText": "Dashboard",
            "getSubMenu": [
                {
                    "menuText": "Dashboard",
                    "folderName": "Dashboard",
                    "pageUrl": "Dashboard/Dashboard",
                    "pageID": "1",
                    "mpageID": "1"
                }
            ]
        },
        {
            "mSortNo": "2",
            "cssClass": "fa fa-file",
            "menuText": "Master",
            "getSubMenu": [
                {
                    "menuText": "Event Master",
                    "folderName": "Master",
                    "pageUrl": "Master/EventMaster",
                    "pageID": "2",
                    "mpageID": "2"
                }
            ]
        },
        {
            "mSortNo": "3",
            "cssClass": "fa fa-refresh",
            "menuText": "Update Record",
            "getSubMenu": [
                {
                    "menuText": "Update Candidate Data",
                    "folderName": "Update",
                    "pageUrl": "Update/UpdateCandidateData",
                    "pageID": "3",
                    "mpageID": "3"
                }
            ]
        },
        {
            "mSortNo": "4",
            "cssClass": "fa fa-upload",
            "menuText": "Upload",
            "getSubMenu": [
                {
                    "menuText": "Upload Candidate Data",
                    "folderName": "Upload",
                    "pageUrl": "Upload/UploadCandidateData",
                    "pageID": "4",
                    "mpageID": "4"
                }, {
                    "menuText": "Upload Candidates file",
                    "folderName": "Upload",
                    "pageUrl": "Upload/UploadCandidateFile",
                    "pageID": "5",
                    "mpageID": "4"
                }
            ]
        },
        {
            "mSortNo": "5",
            "cssClass": "fa fa-file",
            "menuText": "Report",
            "getSubMenu": [
                {
                    "menuText": "Candidate Report",
                    "folderName": "Report",
                    "pageUrl": "Report/CandidateReport",
                    "pageID": "6",
                    "mpageID": "5"
                },{
                    "menuText": "SMS Report",
                    "folderName": "Report",
                    "pageUrl": "Report/SMSReport",
                    "pageID": "7",
                    "mpageID": "5"
                }
            ]
        }
    ],);
    const dispatch = useDispatch()
    const { open } = useSelector((state) => state.header);
    const user = GetSession('cookies', 'user');

    useEffect(() => {
        function handleresize() {
            if (window.innerWidth < 1200) {
                dispatch(setOpen(false));
            } else {
                dispatch(setOpen(true));
            }
        }
        handleresize();
        window.addEventListener("resize", handleresize);
        return () => window.addEventListener("resize", handleresize);
    }, [])

    useEffect(() => {
        if (!user?.loginSessionID)
            NotificationSound('EXPIRED', 'EXPIRED')
    }, [user]);

    return (
        <>
            <aside id="sidebar" className="sidebar" style={open ? {} : { left: "-250px" }}>
                <ul className="sidebar-nav" id="sidebar-nav">
                    {menus !== null &&
                        (menus.map((menu, index) => (
                            <li className="nav-item" style={{ cursor: "pointer" }} key={index}>
                                {menu.getSubMenu !== null ?
                                    (
                                        <>
                                            <div
                                                className={`nav-link collapsed cursor-pointer`}
                                                data-bs-target={`#${(menu.menuText).replaceAll(' ', '').replaceAll('&', '')}`}
                                                data-bs-toggle="collapse"
                                            >
                                                <i className={menu.cssClass} />
                                                <span>{menu.menuText}</span>
                                                <i className="bi bi-chevron-down ms-auto" />
                                            </div>

                                            <ul
                                                id={`${(menu.menuText).replaceAll(' ', '').replaceAll('&', '')}`}
                                                className={`nav-content collapse open sidebar-submenu ${menu.getSubMenu[0].mpageID === localStorage.getItem('ID') ? 'show' : ''}`}
                                                data-bs-parent="#sidebar-nav"
                                            >
                                                {menu.getSubMenu.map((subMenu, i) => (
                                                    <li key={i} className='mx-2 my-1' onClick={() => localStorage.setItem('ID', subMenu.mpageID)}>
                                                        <NavLink to={`/${(subMenu.pageUrl)}`}
                                                            id={subMenu.pageID}>
                                                            <i className={subMenu.cssClass} />
                                                            <span>{(subMenu.menuText).trim()}</span>
                                                        </NavLink>
                                                    </li>
                                                ))}
                                            </ul>
                                        </>
                                    ) : (
                                        <NavLink
                                            className="nav-link collapsed"
                                            cursor-pointer
                                            key={index}
                                            to={`/${menu.pageUrl}`}
                                        >
                                            <i className={menu.cssClass} />
                                            <span>{menu.menuText}</span>
                                            <i className="bi bi-chevron-down ms-auto" />
                                        </NavLink>)}
                            </li>
                        )))}
                </ul>
            </aside>
        </>
    )
}
export default memo(Sidebar);